import type { WallCard } from '@walls/store';
import { isClusterCard } from '../../board/selectors/boardCardSelectors';
import { getCardText, getCardType } from '../../board/utils/cardDisplay';

export const maxThemeGroupingCards = 100;

export function getThemeGroupingEligibleCards(cards: WallCard[]): WallCard[] {
  return cards.filter(
    (card) =>
      !card.parentId &&
      !card.isLocked &&
      !isClusterCard(card) &&
      card.shape?.trim().toLowerCase() !== 'cluster' &&
      getCardType(card) === 'text' &&
      getCardText(card).length > 0
  );
}
